import { render, staticRenderFns } from "./area-select.vue?vue&type=template&id=41d69cd2&"
import script from "./area-select.vue?vue&type=script&lang=ts&"
export * from "./area-select.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports